let ShowHideClickout = (function () {

    function show (instance) {
        document.body.classList.add('clickout-is-visible');
        instance._target.classList.add('visible');
        instance._visible = true;
    }

    function hide (instance) {
        document.body.classList.remove('clickout-is-visible');
        instance._target.classList.remove('visible');
        instance._visible = false;
    }

    function toggleListener (triggers, close, instance) {

        function toggle () {
            if( !instance._visible ) {
                show(instance);
            } else{
                hide(instance);
            }
        }

        triggers.forEach(function(btn) {
            btn.addEventListener('click', toggle);
        });

        close.addEventListener('click', toggle);

        return toggle;

    }

    function backgroundListener (instance) {
        instance._target.addEventListener('click', function(e) {
            if( !e.target.closest('.inner') ) {
                hide(instance);
            }
        });
    }

    function Constructor (element) {

        // get the triggers
        let triggers = document.querySelectorAll('button[data-clickout="' + element.dataset.clickout + '"]');

        // Create the close button
        let close = document.createElement('button');
        close.className = 'close';

        // prepend to clickout
        element.querySelector('.inner').prepend(close);

        // Create the event listener
        let tl = toggleListener(triggers, close, this);

        // Set properties
        Object.defineProperties(this, {
            _target: {value: element, writable: true},
            _triggers: {value: triggers},
            _close: {value: close},
            _toggleListener: {value: tl},
            _visible: {value: false, writable: true}
        });

        backgroundListener(this);
    }

    return Constructor;

})();
